/**
 * Shared "this page is super_admin-only" notice. Imported by each route
 * that's restricted (Pages / Group Content / Layout Templates under the
 * Pages Manager group + /tools).
 *
 * Routes do an inline `if (user.role.slug !== 'super_admin') return
 * <SuperAdminFallback />` AFTER calling all hooks — keeps hook order
 * predictable while still bailing out before rendering the gated UI.
 */
export function SuperAdminFallback() {
  return (
    <div className="p-4 sm:p-8">
      <div className="mx-auto max-w-3xl">
        <div className="rounded-lg border border-slate-200 bg-white p-8 text-center text-sm text-slate-500 dark:border-slate-800 dark:bg-slate-900">
          หน้านี้สำหรับ <span className="font-mono">super_admin</span> เท่านั้น
        </div>
      </div>
    </div>
  );
}
